import styles from './SettingFieldWithIcon.css'
import {Tooltip, OverlayTrigger} from 'react-bootstrap'

class SettingFieldWithIcon extends React.Component {
  render () {
    let {input, meta, type, placeholder, readOnly, maxLength, icon} = this.props
    let {touched, error} = meta
    return (
      <div className={
        touched
          ? (error ? 'has-feedback has-error' : 'has-feedback has-success')
          : ''}>
        <div className='input-group'>
          <input {...input}
            type={type}
            readOnly={readOnly}
            maxLength={maxLength}
            className='form-control'
            placeholder={placeholder}
            onChange={this._onChange}
          />
          {
            touched ? this._renderFeedback() : ''
          }
          <div className='input-group-addon'>
            {icon}
          </div>
        </div>
      </div>
    )
  }

  _onChange = (e) => {
    const nextVal = e.target.value
    const {positiveNumberOnly, input: {onChange}, maxFractionDigits} = this.props
    if (isNaN(nextVal) && positiveNumberOnly) {
      // case if one digit < 0 integer
      if (nextVal === '-') {
        onChange(e, '')
      } else {
        // no op. invalid change
      }
    } else if (maxFractionDigits !== undefined) { // we must check also if == 0, so we check using undefined instead of comparing zero values (!maxFractionDigits
      const dotPosition = nextVal.indexOf('.')
      if (dotPosition !== -1 && nextVal.length - dotPosition - 1 > maxFractionDigits) {
        // no op. invalid change
      } else {
        onChange(e, nextVal)
      }
    } else {
      onChange(e, nextVal)
    }
  }

  _renderFeedback = () => {
    const {meta: {error}} = this.props
    return (
      error
        ? <OverlayTrigger placement='top' overlay={<Tooltip id='tooltip'>{error}</Tooltip>}>
          <span
            className={`${styles['icon-addon']} form-control-feedback glyphicon glyphicon-remove`}
            style={{'pointer-events': 'auto', 'cursor': 'pointer'}}
            />
        </OverlayTrigger>
        : <span className={`${styles['icon-addon']} form-control-feedback glyphicon glyphicon-ok`} />
    )
  }
}

SettingFieldWithIcon.propTypes = {
  positiveNumberOnly: React.PropTypes.bool,
  maxFractionDigits: React.PropTypes.number
}

export default SettingFieldWithIcon



// WEBPACK FOOTER //
// ./app/components/Fields/ReduxForm/SettingFieldWithIcon/SettingFieldWithIcon.js